import { InputsEnum } from '@/enums/inputs';

class InputService {
	static instance = null;

	static getInstance() {
		if (InputService.instance == null) {
			InputService.instance = new InputService();
		}

		return this.instance;
	}

	inputs = new Map();

	listeners = new Map();

	isRegistered(indentifier) {
		return this.inputs.has(indentifier);
	}

	registerInputField(indentifier, type, value, required, onValidate) {
		let cachedValue = value;

		if (this.inputs.has(indentifier)) {
			cachedValue = this.inputs.get(indentifier).value;
			this.inputs.delete(indentifier);
		}

		this.inputs.set(indentifier, {
			type,
			value: cachedValue,
			required,
			onValidate,
			enabled: true,
		});
	}

	unregisterInputField(indentifier) {
		if (this.inputs.has(indentifier)) {
			// We disable this input since we might still need the value
			this.inputs.get(indentifier).enabled = false;
		}
	}

	registerListener(indentifier, onChange) {
		const listeners = [];
		if (this.listeners.has(indentifier)) {
			listeners.push(...this.listeners.get(indentifier));
		}

		this.listeners.set(indentifier, [...listeners, onChange]);
	}

	unregisterListener(indentifier, onChange) {
		if (this.listeners.has(indentifier)) {
			this.listeners.set(
				indentifier,
				this.listeners.get(indentifier).filter(l => l !== onChange)
			);
		}
	}

	storeInputValue(indentifier, value) {
		this.inputs.get(indentifier).value = value;
		if (this.listeners.has(indentifier)) {
			const listeners = this.listeners.get(indentifier);
			for (let i = 0; i < listeners.length; i++) {
				listeners[i]();
			}
		}
	}

	getInputValue(indentifier) {
		const { value } = this.inputs.get(indentifier) || {};
		return value || '';
	}

	getAllInputData() {
		const data = {};

		for (const [indentifier, { value }] of this.inputs) {
			data[indentifier] = value;
		}

		return data;
	}

	validateInputs() {
		let isValid = true;
		const activeInputs = [...this.inputs].filter(([, { enabled }]) => enabled === true);

		for (const [, { type, value, required, onValidate }] of activeInputs) {
			if (required) {
				if (type === InputsEnum.EMAIL) {
					if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
						onValidate(false);
						isValid = isValid && false;
					}
				} else if (type === InputsEnum.CHECKBOX) {
					onValidate(value);
					isValid = isValid && value;
				} else if (!/^.+$/g.test(value)) {
					onValidate(false);
					isValid = isValid && false;
				} else {
					onValidate(true);
				}
			}
		}

		return isValid;
	}
}

export default InputService;
